<template>

<div>

  <LDBsTable
    url="actives-type"
    defaultSort="name"
    defaultOrder="asc"
    :query="query"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-4">
      <label for="actives_type">{{ $t('active_type') }}</label>
      <input
        type="text"
        id="activesType"
        name="activesType"
        class="form-control"
        :placeholder="$t('ph_active_type')"
        v-model="query.name"
        @input="upper('name')"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="prefix">{{ $t('prefix') }}</label>
      <input
        type="text"
        id="prefix"
        name="prefix"
        class="form-control"
        :placeholder="$t('ph_prefix')"
        v-model="query.prefix"
        @input="upper('prefix')"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="isActive">{{ $t('active') }}</label>
      <Combobox
        class="bg-white"
        name='isActive'
        :placeholder="$t('select_a_item')"
        label="label"
        :options="[{ label: 'SIM', value: true }, { label: 'NÃO', value: false } ]"
        v-model="query.isActive"
        :reduce="activeType => activeType.value"
      />
    </div>
  </LDBsTable>

</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'

export default {
  name: 'ActivesTypesList',
  
  components: {
    LDBsTable,
    Combobox
  },
  
  data () {
    return {
      columns: [
        {
          title: this.$t('name'),
          field: 'name',
          sortable: true
        },
        {
          title: this.$t('prefix'),
          field: 'prefix',
          sortable: true
        },
        {
          title: this.$t('location'),
          field: 'location'
        },
        {
          title: this.$t('status'),
          field: 'status',
          formatter: function(value) {
            return value
              ? value.name
              : '-'
          }
        },
        {
          title: this.$t('field_legend') + ' 1',
          field: 'fieldLegend1',
          sortable: true
        },
        {
          title: this.$t('field_legend') + ' 2',
          field: 'fieldLegend2',
          sortable: true
        },
        {
          title: this.$t('field_legend') + ' 3',
          field: 'fieldLegend3',
          sortable: true
        },
        {
          title: this.$t('last_serial'),
          field: 'lastSerialRegistered'
        },
        {
          title: this.$t('active'),
          field: 'isActive',
          formatter: function (value) {
            return value ? 'SIM' : 'NÃO'
          },
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `<a href="#/main/activestype/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'tipos_ativos' }
      },
      query: {
        id: '',
        name: '',
        prefix: '',
        isActive: ''
      }
    }
  },
  
  methods: {
    clear() {
      this.query.name = ''
      this.query.prefix = ''
      this.query.isActive = ''
    },

    upper(attr) {
      this.query[attr] = this.query[attr].toUpperCase()
    }
  }
}
</script>
